import React from 'react';

import { getImagesStaticUrl } from '../../../helpers';
import './styles.scss';

const SaveBanner = ({ getCouponContentKey }) => (
  <section className="save-banner">
    <div className="annual-banner">
      {getCouponContentKey('chatBubble', 'Save $20 by selecting the Annual plan!')}
      <img
        src={getImagesStaticUrl('green-arrow@2x.png')}
        alt="green arrow"
        className="annual-banner__arrow"
      />
    </div>
  </section>
);

SaveBanner.displayName = 'SaveBanner';

export default SaveBanner;
